export const AuthFooter = ({ className = "" }) => (
  <footer className={`text-center text-xs text-slate-400 py-5 ${className}`} data-testid="auth-footer">
    © 2023 Pusat Keuangan | Create Web by{" "}
    <a href="https://hostnesia.id" target="_blank" rel="noopener noreferrer" data-testid="footer-hostnesia-link"
      className="text-[color:var(--brand)] hover:underline">HostNesia.id</a>
  </footer>
);
